import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig, configProblem } from './Constants/Config';

// The backend URLs come from /config.json, written at container start; nothing renders before it is read.
loadConfig().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      {configProblem
        ? <pre style={{ padding: 24, fontFamily: 'monospace' }}>pars-adm cannot start: {configProblem}</pre>
        : <App />}
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
